import { Outlet, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import ProfileContext from 'services/profileContext';
import UpgradeRequired from 'components/upgradeRequired';
import { needUpgrade } from 'utils/utils';

const ProtectedLayout = () => {
  const profile = useContext(ProfileContext);
  const location = useLocation();
  const isPaymentSuccess = location.pathname === '/payment-success';

  if (needUpgrade(profile) && !isPaymentSuccess) {
    return <UpgradeRequired />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
